import { render, staticRenderFns } from "./formClientEmergency.vue?vue&type=template&id=00464b93&"
import script from "./formClientEmergency.vue?vue&type=script&lang=js&"
export * from "./formClientEmergency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports